import React, { useEffect } from "react";

import { store } from "../../../store/store";
import { dispatchCloseModalEvent } from "../../../utils/helpers";


const EscapeHandler: React.FC = () => {

	useEffect(() => {
		document.addEventListener('keydown', escapeHandler);
		// eslint-disable-next-line
	},[])

	const closeLastWindow = () => {
		const modals = store.getState().modals.openedModals;
		if (modals.length > 0){
			const lastWindow = modals[modals.length -1];
			dispatchCloseModalEvent(lastWindow.modalName, lastWindow.modalId);
		}
	}

	const escapeHandler = (e: KeyboardEvent) => {
		if (e.key === 'Escape'){
			setTimeout(() => {
				closeLastWindow();
			});
		}
	};


	return null;
}

export default EscapeHandler;